
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locations/mexico/[locationSlug]",
      function () {
        return require("private-next-pages/locations/mexico/[locationSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/locations/mexico/[locationSlug]"])
      });
    }
  